import { useStore } from '@tanstack/react-store';

import type { FeatureFlag } from '@/stores/feature-flags';

import { featureFlagsStore } from '@/stores/feature-flags';

export type UseFeatureFlagOptions = {
    flag: FeatureFlag;
    defaultValue?: boolean;
};

export function useFeatureFlag({ flag, defaultValue }: UseFeatureFlagOptions) {
    const store = useStore(featureFlagsStore, state => state[flag]);

    return store ?? defaultValue;
}
